import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ClockIcon } from "../assets/clock.svg";
import { ReactComponent as ArrowIcon } from "../assets/arrow-up-2.svg";
import { parseHoursOfOperation, createLinkParser } from "../services";
import { handleRedirect } from "../../../utils/CommonFunctions";
import { DAY_NAMES } from "../constants";

interface OpenHoursProps {
  metadata?: any;
}

const dayNames = DAY_NAMES;

const OpenHours = ({ metadata }: OpenHoursProps) => {
  const [showMore, setShowMore] = useState(false);
  const history = useNavigate();
  const parseWithLinks = createLinkParser(handleRedirect, history, "RECO_ENGINE");

  const hoursSched = metadata?.hours;
  const hoursText = metadata?.hours_of_operation;

  const parsedHours = parseHoursOfOperation(hoursSched);
  const today = new Date();
  const currentDayIndex = today.getDay();
  const currentDayName = dayNames[currentDayIndex];

  const todayHours = parsedHours?.[currentDayName];
  const isOpen = todayHours?.openNow;

  const toggleShowMore = () => setShowMore((prev) => !prev);

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      toggleShowMore();
    }
  };

  const renderFullSchedule = () => (
    <div 
      onClick={toggleShowMore}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      className="full-sched"
      aria-label="Toggle hours schedule"
    >
      <table>
        <tbody>
          {Object.entries(parsedHours).map(([day, time]) => (
            <tr key={day}>
              <td
                className={day === currentDayName ? (isOpen ? "today-open" : "today-closed") : ""}
              >
                {day}
              </td>
              <td>
                {/* eslint-disable-next-line @typescript-eslint/dot-notation */}
                {time["closed"] ? "Closed" : `${time["open"] ?? ""} - ${time["close"] ?? ""}`}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <ArrowIcon className="arrow-flipped" />
    </div>
  );

  const renderTodayOnly = () => (
    <div 
      onClick={toggleShowMore}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      className="full-sched"
      aria-label="Toggle hours schedule"
    >
      <table>
        <tbody>
          <tr>
            <td className={`${isOpen ? "today-open" : "today-closed"}`}>
              {isOpen ? "Open" : currentDayName}
            </td>
            <td>
              {todayHours?.closed
                ? "Closed"
                : `${todayHours?.open ?? ""} - ${todayHours?.close ?? ""}`}
            </td>
          </tr>
        </tbody>
      </table>
      <ArrowIcon className="arrow" />
    </div>
  );

  return (
    <>
      {metadata?.hours || metadata?.hours_of_operation ? (
        <div className={`recoEngine__hours ${showMore ? "showHours" : "hideHours"}`}>
          <ClockIcon />
          {parsedHours ? (
            showMore ? (
              renderFullSchedule()
            ) : (
              renderTodayOnly()
            )
          ) : (
            <p>{parseWithLinks(hoursText)}</p>
          )}
        </div>
      ) : null}
    </>
  );
};

export default OpenHours;
